import PropTypes from 'prop-types'
import { useState } from 'react'

import cn from '@/utilities/cn'

import { numericOnly } from './validations'

import './index.scss'

const requiredSymbol = '*'

const MaterialInput = ({
  onBlur,
  required,
  placeholderAsTitle,
  subtitle,
  placeholder,
  name,
  value = '',
  type = 'text',
  validation,
  onChange,
  min
}: any) => {
  const [isFocused, setFocused] = useState(false)

  const trimmedValue = typeof value === 'string' ? value.trim() : value
  const isRaised = trimmedValue !== ''

  // If numeric, disable any letter keypresses
  let validationFunction: any
  if (validation) {
    validationFunction = validation
  } else {
    if (type === 'number') {
      validationFunction = numericOnly
    }
  }

  const onKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which
    // eslint-disable-next-line unicorn/prefer-code-point
    const keyValue = String.fromCharCode(keyCode)
    if (validationFunction && !validationFunction(keyValue)) {
      e.preventDefault()
    }
  }

  return (
    <>
      <div className="material-textbox">
        {placeholderAsTitle && (
          <div className={cn('placeholder', { focus: isFocused, raised: isRaised || isFocused })}>
            {required && <div className="label__icon">{requiredSymbol}</div>} {placeholder}
          </div>
        )}

        <div className={cn('input-box', { focus: isFocused })}>
          <input
            alt={name}
            type={type}
            placeholder={placeholderAsTitle ? '' : placeholder}
            name={name}
            className={isFocused ? 'focus' : ''}
            onKeyPress={onKeyPress}
            onChange={onChange}
            onBlur={e => {
              setFocused(false)
              if (onBlur) onBlur(e)
            }}
            onFocus={() => {
              setFocused(true)
            }}
            value={value}
            min={min}
          />
        </div>
      </div>
      {!!subtitle && <div className="subtitle">{subtitle}</div>}
    </>
  )
}

MaterialInput.propTypes = {
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  placeholderAsTitle: PropTypes.bool,
  subtitle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  placeholder: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  name: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  min: PropTypes.number
}

MaterialInput.defaultProps = {
  onBlur: () => {},
  required: false,
  placeholderAsTitle: false,
  subtitle: undefined,
  placeholder: '',
  name: undefined,
  value: '',
  type: 'text',
  onChange: () => {},
  min: undefined
}

export default MaterialInput
